import { FunctionComponent } from 'react';
import OnboardingPerson1 from '../Assets/Images/Onboarding/onboarding-person-1.jpg';
import OnboardingPerson2 from '../Assets/Images/Onboarding/onboarding-person-2.jpg';
import OnboardingUSC from '../Assets/Images/Onboarding/onboarding-usc.jpg';
import OnboardingConfirmation from '../Assets/Images/Onboarding/onboarding-confirmation.jpg';
import Wellness from '../Assets/Images/Placeholders/Wellness.jpg';
import { ReactComponent as YogaSVG } from '../Assets/Images/SportsIllustrations/Yoga.svg';
import { ReactComponent as DancingSVG } from '../Assets/Images/SportsIllustrations/Dancing.svg';
import { ReactComponent as EmsSVG } from '../Assets/Images/SportsIllustrations/EmsSVG.svg';
import { ReactComponent as FitnessSVG } from '../Assets/Images/SportsIllustrations/Fitness.svg';
import { ReactComponent as MartialArtsSVG } from '../Assets/Images/SportsIllustrations/MartialArts.svg';
import { ReactComponent as OutdoorSVG } from '../Assets/Images/SportsIllustrations/Outdoor.svg';
import { ReactComponent as CrossfitSVG } from '../Assets/Images/SportsIllustrations/Crossfit.svg';
import { ReactComponent as PersonalTrainingSVG } from '../Assets/Images/SportsIllustrations/PersonalTraining.svg';
import { ReactComponent as PilatesSVG } from '../Assets/Images/SportsIllustrations/Pilates.svg';
import { ReactComponent as SwimmingSVG } from '../Assets/Images/SportsIllustrations/Swimming.svg';
import { ReactComponent as WellnessSVG } from '../Assets/Images/SportsIllustrations/Wellness.svg';
import { ReactComponent as OtherSVG } from '../Assets/Images/SportsIllustrations/Other.svg';
import uscLogo from '~/Assets/Images/usc_logo_dark.png';
import PPLogo from '~/Assets/Images/Brand/pp-logo.svg';

const IMAGES = {
  FitogramProLogo: uscLogo,
  BRAND: {
    LOGO_WHITE: PPLogo,
  },
  ONBOARDING: {
    person_1: OnboardingPerson1,
    person_2: OnboardingPerson2,
    confirmation: OnboardingConfirmation,
    usc: OnboardingUSC,
    uscLogo,
  },
};

export const PLACEHOLDERS = {
  Wellness,
};
interface ILLUSTRATIONS {
  [sport: string]: FunctionComponent;
}

export const ILLUSTRATIONS: ILLUSTRATIONS = {
  PersonalTraining: PersonalTrainingSVG,
  Pilates: PilatesSVG,
  Dancing: DancingSVG,
  Fitness: FitnessSVG,
  Swimming: SwimmingSVG,
  Ems: EmsSVG,
  Outdoor: OutdoorSVG,
  Wellness: WellnessSVG,
  Yoga: YogaSVG,
  Other: OtherSVG,
  Crossfit: CrossfitSVG,
  MartialArts: MartialArtsSVG,
};
export default IMAGES;
